<ng-container *ngIf="isVisible">
    <ng-container [ngSwitch]="field.type">
        <!-- Text Field -->
        <app-text-field *ngSwitchCase="FieldType.Text" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-text-field>

        <!-- Number Field -->
        <app-text-field *ngSwitchCase="FieldType.Number" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-text-field>

        <!-- Select Field -->
        <app-select-field *ngSwitchCase="FieldType.Select" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-select-field>

        <!-- Date Field -->
        <app-date-field *ngSwitchCase="FieldType.Date" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-date-field>

        <!-- Autocomplete Field -->
        <app-autocomplete-field
            *ngSwitchCase="FieldType.Autocomplete"
            [field]="field"
            [control]="control"
            [fieldId]="fieldId"
        >
        </app-autocomplete-field>

        <!-- Toggle Field -->
        <app-toggle-field *ngSwitchCase="FieldType.Toggle" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-toggle-field>

        <!-- Checkbox Field -->
        <app-checkbox-field *ngSwitchCase="FieldType.Checkbox" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-checkbox-field>

        <!-- Range Field -->
        <app-range-field *ngSwitchCase="FieldType.Range" [field]="field" [control]="control" [fieldId]="fieldId">
        </app-range-field>

        <!-- UI Elements -->
        <ng-container *ngSwitchCase="FieldType.UI">
            <ng-container [ngSwitch]="getUIType(field)">
                <!-- Button Element -->
                <app-button-element
                    *ngSwitchCase="UIElementType.Button"
                    [field]="field"
                    [isReadOnly]="isReadOnly"
                >
                </app-button-element>

                <!-- Icon Element -->
                <app-icon-element
                    *ngSwitchCase="UIElementType.Icon"
                    [field]="field"
                    [isReadOnly]="isReadOnly"
                >
                </app-icon-element>

                <!-- Image Element -->
                <app-image-element
                    *ngSwitchCase="UIElementType.Image"
                    [field]="field"
                    [isReadOnly]="isReadOnly"
                >
                </app-image-element>

                <!-- Text Element -->
                <app-text-element *ngSwitchCase="UIElementType.Text" [field]="field"> </app-text-element>

                <!-- Menu Element -->
                <app-menu-element
                    *ngSwitchCase="UIElementType.Menu"
                    [field]="field"
                    [isReadOnly]="isReadOnly"
                >
                </app-menu-element>

                <!-- Divider Element -->
                <app-divider-element
                    *ngSwitchCase="UIElementType.Divider"
                    [field]="field"
                    [isReadOnly]="isReadOnly"
                ></app-divider-element>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>
